import { normalizeLandstarProductImageUrl } from "../utils/helpers.js";

function RewardSummaryList({ products }) {
  if (!Array.isArray(products) || !products.length) {
    return null;
  }

  return (
    <div className="landstar-reward-summary-list">
      {products.map((product, index) => {
        const imageUrl = normalizeLandstarProductImageUrl(product.image || "");

        return (
          <article
            className="landstar-reward-summary-item"
            key={`${product.sku || product.name || "reward"}-${product.selectedSize || "size"}-${product.selectedColor || "color"}-${index}`}
          >
            {imageUrl ? (
              <img
                src={imageUrl}
                alt={product.name || `Reward ${index + 1}`}
                className="landstar-checkout-summary-image"
              />
            ) : null}

            <div className="landstar-reward-summary-details">
              <span className="landstar-driver-summary-label">Reward {index + 1}</span>
              <strong>{product.name || "Landstar reward"}</strong>
              <div className="landstar-reward-summary-options">
                <span>
                  <strong>Size:</strong> {product.selectedSize || "N/A"}
                </span>
                <span>
                  <strong>Color:</strong> {product.selectedColor || "N/A"}
                </span>
                {product.personalization ? (
                  <span>
                    <strong>Personalization:</strong> {product.personalization}
                  </span>
                ) : null}
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
}

export default RewardSummaryList;
